<template>
	<div class="container_page">
		<a-form layout="inline">
			<a-form-item label="产品名称">
				<a-input placeholder="请输入产品名称" v-model="filterData.productName" />
			</a-form-item>
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>
				<a-button class="mr12" @click="handleExport">导出</a-button>
				<a-button icon="plus" v-if="lang === 'CH'" @click="toAdd"  type="primary">新建SKU</a-button>
			</a-form-item>
		</a-form>
		<!-- 分类标签栏 -->
		<div class="cate">
			<a-radio-group v-model="filterData.productCategroy" button-style="solid" @change="changeTab">
				<a-radio-button value="">
					全部
				</a-radio-button>
				<a-radio-button value="CAT">
					猫咪
				</a-radio-button>
				<a-radio-button value="DOG">
					狗狗
				</a-radio-button>
			</a-radio-group>
		</div>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="productStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.productStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.productStatus == 1">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else-if="record.productStatus == 0">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>

			</template>


			<template slot="productCategroyRender" slot-scope="text, record">
				<div >
					{{ record.productCategroy  == "DOG" ? "狗" : "猫"}}
				</div>
			</template>
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template>
			<template slot="action" slot-scope="text, record">
				<span><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
					<a-button type="link" v-if="lang === 'CH'">删除</a-button>
				</a-popconfirm>
			</template>
		</a-table>
		<a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
			<template slot="footer">
				<a-button @click="imgModel.flag = false">关闭</a-button>
			</template>
			<span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px" />
			</span>
		</a-modal>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="分类">
							<a-radio-group name="radioGroup" v-model="editModel.businessType">
								<a-radio value="FACTORY"> 工厂 </a-radio>
								<a-radio value="BRABD"> 品牌 </a-radio>
								<a-radio value="SUPPLIER"> 供应商 </a-radio>
							</a-radio-group>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="logo">
							<div style="display: flex;align-items: center;">
								<div v-if="editModel.businessLogo">
									<viewer :images="[editModel.businessLogo]">
										<div class="er_content">
											<img class="er_content_img" :src="img"
												v-for="(img,index) in [editModel.businessLogo]" :key="index">
										</div>
									</viewer>
								</div>
								<div class="again_upload_box ml12">
									<input type="file" accept="image/*" @change="handleUpdataFile" />
									<i class="el-icon-box again_upload_icon"></i>
									<div class="bold" style="width: 100px">
										{{ editModel.businessLogo ? "重新上传" : "上传logo" }}
									</div>
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="名称" prop="businessName">
							<a-input placeholder="请输入名称" style="width: 180px;" v-model="editModel.businessName" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="英文名称" prop="businessEnName">
							<a-input placeholder="请输入英文名称" style="width: 180px;" v-model="editModel.businessEnName" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		getFactoryProductsApi, //主营产品
		getFactoryProductDetailApi, //主营产品详情
		saveFactoryProductApi, //主营产品 新增/编辑
		deleteFactoryProductApi, //  主营产品 删除
		exportFactoryProductsApi, //主营产品 导出
		updateFactoryProductStatusApi, //主营产品 修改状态
		updateFactoryProductSortApi //主营产品 修改序号
	} from "../../../api/index";
	import {
		ossUpload
	} from "../../../utils/oss";
	export default {
		name: "MainProductTab",

		props: {
			// 接收 id，严格限制为数字类型
			factoryLangId: {
				type: Number,
				required: true, // 必传
				default: 0 // 默认值
			},
			lang: {
				type: String,
				default: 'CH'
			}
		},

		data() {
			return {
				activeTab: 'FACTORY',
				columns: [{
						title: 'ID',
						dataIndex: 'productCode',
						key: 'productCode',
					},
					{
						title: '产品名称',
						dataIndex: 'productName',
						key: 'productName',
					},
					// 猫/狗分类  CAT 猫  DOG 狗
					{
						title: '猫/狗',
						dataIndex: 'productCategroy',
						key: 'productCategroy',
						scopedSlots: {
							customRender: "productCategroyRender"
						},
					},
					// "tagName": "4.5", //产品分类
					{
						title: '产品分类',
						dataIndex: 'tagName',
						key: 'tagName',
					},
					{
						title: '状态',
						dataIndex: 'productStatus',
						key: 'productStatus',
						scopedSlots: {
							customRender: "productStatusRender"
						},
					},
					{
						title: '排序',
						dataIndex: 'sort',
						key: 'sort',
						scopedSlots: {
							customRender: "indexSortender"
						},
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						key: 'createTime'
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [

				],
				pageInfo: {
					pageSize: 10,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					giftCardId: 0,
					giftCardStatus: undefined,
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "新建其他标签信息",
					"businessId": 0, //工厂名称ID/品牌Id
					"businessLogo": "", //LOGO
					"businessName": "", //工厂名称/品牌名称
					"businessEnName": "", //工厂名称/品牌名称  英文
					"businessType": "", //类型    FACTORY 工厂 、BRABD 品牌 、SUPPLIER 供应商
					onOk: () => {},
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					productName: "",
					factoryLangId: 'CH',
					productCategroy: "",
				},
			};
		},
		created() {},
		activated() {},
		watch: {
			factoryLangId(newId, oldId) {
				if (newId && newId !== oldId) {
					this.getData(1);
				}
			}
		},
		mounted() {
			const storedQuery = localStorage.getItem('fctory_band_spplierManage_searchQuery');
			if (storedQuery) {
				const parsed = JSON.parse(storedQuery);
				this.filterData = {
					productName: parsed.productName || '',
					factoryLangId: parsed.factoryLangId || 'CH',
					productCategroy: parsed.productCategroy || ''
				};
			} else {
				this.filterData.productCategroy = '';
			}
			if (this.factoryLangId) {
				this.getData(1);
			}
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('fctory_band_spplierManage_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {

			handleExport() {
				this.loading = true;
				exportFactoryProductsApi({
					factoryLangId: this.factoryLangId,
					productName: this.filterData.productName,
					productCategroy: this.filterData.productCategroy
				}).then((res) => {
					const blob = new Blob([res]);
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = '主营产品.xlsx';
					link.click();
					URL.revokeObjectURL(link.href);
				}).catch(() => {
					this.$message.error('导出失败');
				}).finally(() => {
					this.loading = false;
				});
			},
			// 切换发布状态（带确认提示）
			handlePublishChange(checked, record) {
				// 动态生成提示文案
				let content = '';
				if (checked) {
					// 切换为 启用
					content = '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？';
				} else {
					// 切换为 禁用
					content = '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
				}
				this.$confirm({
					title: '操作确认',
					content: content,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						// 确认后执行的操作
						// record.standardStatus = checked ? 1 : 0; // 接口需要数字，存回数字
						// 这里可以调用接口更新状态
						// TODO
						this.updateStatusApi(record.factoryProductId)
					},
					onCancel: () => {
						console.log('已取消操作');
					}
				});
			},
			updateStatusApi(factoryProductId) {
				updateFactoryProductStatusApi({
						factoryProductId: factoryProductId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								"修改成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
			},

			// 保存排序（输入框回车/失焦触发）
			handleSaveSort(record) {
				// 排序号为空不提交
				if (record.sort === undefined || record.sort === null || record.sort === '') {
					return
				}
				// 调用你已有的排序接口
				updateFactoryProductSortApi({
					factoryProductId: record.factoryProductId,
					sort: record.sort
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current) // 刷新列表，实现重排
					} else {
						this.$message.error('保存失败')
					}
				}).catch(err => {
					this.$message.error('保存失败')
				})
			},

			onTabChange(key) {
				console.log('Tab changed to:', key);
				this.activeTab = key;
				// 如果是接口请求数据，可以在这里调用接口
				this.getData(1);
			},
			changeTab(value) {
				console.log('Tab changed to:', value);
				this.filterData.businessType = value.target.value;
				this.getData();
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						productName: "",
						factoryLangId: 'CH',
						productCategroy: "",
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				if (!this.factoryLangId) {
					this.tableData = [];
					this.pageInfo.total = 0;
					return;
				}
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getFactoryProductsApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						productName: this.filterData.productName,
						factoryLangId: this.factoryLangId,
						productCategroy: this.filterData.productCategroy,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.records || [];
							this.pageInfo.total = res.resultData.totalNum || 0;
						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.$emit('to-add')
			},
			toEdit(data) {
				this.$emit('to-edit', data)
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			sureDelete(record) {
				if (this.loading) {
					return;
				}
				this.loading = true;
				deleteFactoryProductApi({
						factoryProductId: record.factoryProductId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 上传文件
			handleUpdataFile(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					if (file) {
						ossUpload(file, '', 'image/').then((res) => {
							this.editModel.businessLogo = res.url;
						}).catch(err => {
							console.log("上传失败", err);
							this.$message.error('图片上传失败')
						});
					}
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.container_page {

		.cate {
			margin: 20px 0;

			.ant-radio-button-wrapper {
				width: 100px !important;
				text-align: center !important;
			}
		}

		.mr12 {
			margin-right: 12px;
		}
	}
</style>
